const fiveFourSchema = {
  title: "5_4 Investments",
  addAPI: "cat5_4AddEmissionActivityAPI",
  cat: "cat5_4",
  EATitle: "Emission Activity",
  fields: [
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Activity Name",
      resetOnChange: false,
      required: true,
    },
  ],
};
export default fiveFourSchema;
